import React, { useState, useEffect, useContext } from 'react';
import ReactApexChart from 'react-apexcharts';
import ENDPOINT from '../../context/EndPoint';
import axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../context/SecurityHeaders';

const ModeWiseCourseRegistration = () => {
  const { user } = useContext(AuthContext);
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChartData = async () => {
      const data = new FormData();
      data.append('session', user?.SessionId);
      try {
        const response = await axios.post(
          ENDPOINT + 'get-registration-chart.php',
          data,
          SecurityHeaders
        );
        const result = response.data;

        if (result.status === 'success' && result.data) {
          // Always override tooltip formatter with a function
          setChartData({
            series: result.data.series,
            options: {
              ...result.data.options,
              tooltip: {
                ...result.data.options.tooltip,
                y: {
                  formatter: (val) => `₹ ${val}`,
                },
              },
            },
          });
        } else {
          setError(result.message || 'No data');
        }
      } catch (err) {
        setError('Failed to fetch data from the server');
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [user]);

  if (loading) {
    return <div className="m-3 rounded">Loading...</div>;
  }

  if (error) {
    return <div className="m-3 rounded text-danger">{error}</div>;
  }

  return (
    <div className=" bg-white p-3">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={425}
      />
    </div>
  );
};

export default ModeWiseCourseRegistration;